import { toast } from "react-toastify";
import { callApi } from "../../config/apiCall";
import { Saas_Api, SAAS_BASE_URL } from "../../config/apiEndPoints";
import { types } from "../constants/types";
import { call, put, takeLatest } from "redux-saga/effects";

const userDetails = sessionStorage.getItem("userDetails")
  ? JSON.parse(sessionStorage.getItem("userDetails"))
  : {};

function* getHolidayAction(action) {
  try {
    const response = yield call(
      callApi,
      Saas_Api?.GET_HOLIDAY,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_HOLIDAY_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_HOLIDAY_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_HOLIDAY_FAILED, error: error.response });
  }
}

export function* watchGetHolidaysAction() {
  yield takeLatest(types.GET_HOLIDAY_REQUEST, getHolidayAction);
}

function* getEmployeeProfileAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_EMPLOYEE_PROFILE}?employee_id=${action?.payload}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_EMPLOYEEPROFILE_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_EMPLOYEEPROFILE_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
        // localStorage.clear()
        sessionStorage.clear()
        window.location = "/login"
      }
    } 
  } catch (error) {
    // console.log(error);
    if(!error.response.data?.authenticated){
      toast.warning(error.response.data?.message||"Token miss match or expired !")
      sessionStorage.clear()
      window.location = "/login"

    }
    
    yield put({
      type: types.GET_EMPLOYEEPROFILE_FAILED,
      error: error.response,
    });
  }
}

export function* watchGetEmployeeProfileAction() {
  yield takeLatest(types.GET_EMPLOYEEPROFILE_REQUEST, getEmployeeProfileAction);
}

function* getReminderDetailsAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.ADMIN_REMINDER}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );

    if (response?.authenticated) {
      if (response?.valid) {
        yield put({
          type: types.GET_REMINDER_SUCCESS,
          payload: response,
        });
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_REMINDER_FAILED, error: error.response });
  }
}

export function* watchGetReminderDetailsAction() {
  yield takeLatest(types.GET_REMINDER_REQUEST, getReminderDetailsAction);
}

function* getSalaryAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.SALARY_CALCULATION}?id=${action.payload}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("respEmpLeaveREquest" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_SALARY_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_SALARY_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_SALARY_FAILED, error: error.response });
  }
}

export function* watchGetSalaryAction() {
  yield takeLatest(types.GET_SALARY_REQUEST, getSalaryAction);
}

function* getEmpSalaryDataAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_EMPLOYEE_SALARY}?employee_id=${action?.payload}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("respEmpSalaryData", response);
    if (response?.authenticated) {
      if (response?.valid) {
        yield put({
          type: types.GET_EMPSALARYDATA_SUCCESS,
          payload: response?.data,
        });
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_EMPSALARYDATA_FAILED, error: error.response });
  }
}

export function* watchGetEmpSalaryDataAction() {
  yield takeLatest(types.GET_EMPSALARYDATA_REQUEST, getEmpSalaryDataAction);
}

function* getEmpLeaveRequestAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_EMP_LEAVEREQUEST}?employee_id=${action.payload}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("EMP_LEAVEREQUEST" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_EMP_LEAVEREQUEST_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_EMP_LEAVEREQUEST_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({
      type: types.GET_EMP_LEAVEREQUEST_FAILED,
      error: error.response,
    });
  }
}

export function* watchGetEmpLeaveRequestAction() {
  yield takeLatest(
    types.GET_EMP_LEAVEREQUEST_REQUEST,
    getEmpLeaveRequestAction
  );
}

function* getAllInvoiceAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_ALL_INVOICE}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("GET_ALL_INVOICE" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_ALL_INVOICE_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_ALL_INVOICE_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_ALL_INVOICE_FAILED, error: error.response });
  }
}

export function* watchGetAllInvoiceAction() {
  yield takeLatest(types.GET_ALL_INVOICE_REQUEST, getAllInvoiceAction);
}



function* getAssignAssetsAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_ASSIGN_ASSET}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("GET_ALL_INVOICE" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_ASSIGN_ASSET_SUCCESS,
            payload: response?.data,
          });
        } else {
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_ASSIGN_ASSET_FAILED, error: error.response });
  }
}

export function* watchGeAssignAssetsAction() {
  yield takeLatest(types.GET_ASSIGN_ASSET_REQUEST, getAssignAssetsAction);
}


function* getCustomerAction(action) {
  try {
    const response = yield call(
      callApi,
      `${Saas_Api.GET_CUSTOMER}`,
      "GET",
      null,
      userDetails?.token,
      SAAS_BASE_URL
    );
    // //console.log("Customer" ,response);
    if (response?.authenticated) {
      if (response?.valid) {
        if (response?.success) {
          yield put({
            type: types.GET_CUSTOMER_SUCCESS,
            payload: response?.data,
          });
        } else {
          yield put({
            type: types.GET_CUSTOMER_SUCCESS,
            payload: [],
          });
          toast.error(response?.data?.mssg);
        }
      } else {
        toast.error(response?.data?.mssg[0]);
      }
    } 
  } catch (error) {
    yield put({ type: types.GET_CUSTOMER_FAILED, error: error.response });
  }
}

export function* watchGetCustomerAction() {
  yield takeLatest(types.GET_CUSTOMER_REQUEST, getCustomerAction);
}
